export default [
    {
        name: 'object',
        path: 'object',
        redirect: {
            name: 'ObjectCustomize',
        },
        component: () => import('@common/views/app-resource/object/index'),
        children: [
            {
                name: 'ObjectSystem',
                path: 'system',
                meta: {
                    title: '系统对象',
                    iconName: 'left-nav.object-system',
                },
                component: () => import('@common/views/app-resource/object/system-object'),
                children: [
                    {
                        name: 'ObjectSystem',
                        path: ':objectId',
                        meta: {
                            title: '对象详情',
                        },
                        component: () => import('@common/views/app-resource/object/object-detail'),
                    },
                ],
            },
            {
                name: 'ObjectCustomize',
                path: 'customize',
                meta: {
                    title: '服务对象',
                    iconName: 'left-nav.object-customize',
                },
                component: () => import('@common/views/app-resource/object/object'),
                children: [
                    {
                        name: 'ObjectDetail',
                        path: ':objectId',
                        meta: {
                            title: '对象详情',
                        },
                        component: () => import('@common/views/app-resource/object/object-detail'),
                    },
                ],
            },
            {
                name: 'ObjectsSetting',
                path: 'setting',
                meta: {
                    title: '配置对象',
                    disabled: true,
                    iconName: 'left-nav.object-setting',
                },
            },
            {
                name: 'ObjectMock',
                path: 'mock',
                meta: {
                    title: '演示数据',
                    iconName: 'left-nav.object-mock',
                    hideNav(store) {
                        return !!store?.state?.modeling?.app?.enabledMultiBranch
                    },
                },
                component: () => import('@common/views/app-resource/object/mock'),
            },
        ],
    },
    {
        name: 'service',
        path: 'service',
        redirect: {
            name: 'ServiceManage',
        },
        component: () => import('@common/views/app-resource/service/index'),
        children: [
            {
                name: 'SystemOperation',
                path: 'system-operation',
                meta: {
                    title: '系统操作',
                    iconName: 'left-nav.system-operation',
                },
                component: () => import('@common/views/app-resource/system-operation'),
            },
            {
                name: 'FrontendOperation',
                path: 'frontend-operation',
                meta: {
                    title: '前端操作',
                    iconName: 'left-nav.frontend-operation',
                },
                component: () => import('@common/views/app-resource/frontend-operation'),
            },
            {
                path: 'service-api',
                meta: {
                    title: '后端操作',
                    iconName: 'left-nav.service-api',
                    tips:
                        '后端服务接口，可以打通多方数据或调用开放的服务。只需填写少量信息即可在应用内调用。',
                },
                component: () => import('@common/views/app-resource/service/service'),
                children: [
                    {
                        name: 'ServiceManage',
                        path: '',
                        component: () => import('@common/views/app-resource/service/service-management'),
                    },
                    {
                        name: 'ServiceDetail',
                        path: 'detail/:type/:id?',
                        meta: {
                            title: params => (params.id ? '编辑后端操作' : '新建后端操作'),
                            hideNav: true,
                        },
                        component: () => import('@common/views/app-resource/service/service-editor'),
                    },
                ],
            },

            // {
            //     name: 'service-arrange',
            //     path: 'service-arrange',
            //     meta: {
            //         title: '业务编排',
            //         iconName: 'left-nav.service-arrange',
            //     },
            //     component: () => import('@common/views/app-resource/service/service-arrange'),
            // },
        ],
    },
    {
        name: 'nav',
        path: 'nav',
        meta: {
            title: '导航',
        },
        component: () => import('@common/views/app-navigator/designer'),
    },

    {
        name: 'setting',
        path: 'setting',
        redirect: {
            name: 'theme',
        },
        component: () => import('@common/views/setting'),
        children: [
            // {
            //     name: 'role',
            //     path: 'role',
            //     meta: {
            //         title: '角色权限',
            //         iconName: 'left-nav.role',
            //     },
            //     component: () => import('@common/views/workspace/role-auth'),
            // },
            {
                name: 'theme',
                path: 'theme',
                meta: {
                    title: '主题风格',
                    iconName: 'left-nav.theme',
                    // 支持基础 markdown 语法
                    tips:
                        '主题风格用于配置应用全局标准页面和组件的展示样式，支持统一管理主题并快速配置和启用，所有分支共用一份数据。目前平台提供官方主题方案，并支持自定义多套主题样式。点击了解[更多详情](https://open.mingyuanyun.com/docs/mpaas/latest/app-setting/theme-settings)。',
                },
                component: () => import('@common/views/app-setting/theme'),
            },
            {
                name: 'theme-design',
                path: 'theme-design/:id',
                meta: {
                    title: '主题设计',
                    withoutBreadcrumb: true,
                    hideNav: true,
                    fullscreen: true,
                },
                component: () => import('@common/views/app-setting/theme-designer'),
            },
            {
                name: 'components',
                path: 'components',
                meta: {
                    title: '组件库',
                    iconName: 'left-nav.components',
                },
                component: () => import('@common/views/workspace/components'),
            },
            {
                name: 'app-setting',
                path: 'app-setting',
                meta: {
                    title: '预览设置',
                    iconName: 'left-nav.setting',
                },
                component: () => import('@common/views/workspace/setting'),
            },
        ],
    },
]
